module.exports = __webpack_public_path__ + "img/210b528b5b814b2e23ff83e4fc25f71b.png";